import { Box, Button, Stack, ThemeProvider, Typography } from "@mui/material";
import Header from "./Header";

import themes from "../themes";

export default function HomePage() {
  return (
    <ThemeProvider theme={themes.defaultTheme}>
    <Box sx={{ minHeight: "100vh", bgcolor: "white" }}>
      {/* Header */}
      <Header/>

      {/* Main content */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          px: { xs: 2, sm: 3 },
          py: { xs: 4, sm: 6 },
        }}
      >
        {/* Flat container */}
        <Box
          sx={{
            width: "100%",
            maxWidth: 360,
            px: 3,
            py: 4,
            bgcolor: "white",
            borderRadius: 0.5, // minimal radius
            border: "1.5px solid #0c3353", // visible border
            boxShadow: "0 1px 2px rgba(0,0,0,0.05)", // subtle shadow
          }}
        >
          <Stack spacing={3}>
            <Typography
              variant="myTitle"
              textAlign="center"
              fontWeight={700}
              color="black"
              fontSize={30}
            >
سامانه ثبت درخواست سفر عمره            </Typography>

            {/* Buttons as links */}
            <Button
              component="a"
              href="/login"
              variant="contained"
              size="large"
              fullWidth
              sx={{
                textTransform: "none",
                fontWeight: 600,
                borderRadius: 0.5,
                fontSize:20
              }}
              
            >
              ورود
            </Button>

            <Button
              component="a"
              href="/register/guest"
              variant="outlined"
              size="large"
              fullWidth
              sx={{
                textTransform: "none",
                fontWeight: 600,
                color: "#0c3353",
                borderColor: "#0c3353",
                borderRadius: 0.5,
                fontSize:20
              }}
            >
              ثبت نام
            </Button>

           
          </Stack>
        </Box>
      </Box>
    </Box>
    </ThemeProvider>
  );
}
